export enum EventType {
    OPEN_PREFERENCE_DRAWER = 'OPEN_PREFERENCE_DRAWER',
    UPDATE_MENUS = 'UPDATE_MENUS',
    LOGOUT = 'LOGOUT',
    REFETCH_FILE_UPLOAD_LISTING = 'REFETCH_FILE_UPLOAD_LISTING',
}
